/**
 * Product Yotpo Subs
 */

const productYotpoSubs = () => {
  const config = {
    dom: {
      yotpoSubs: ".yotpo-selling-plans-wrapper",
      yotpoSelectedPrice: ".yotpo-selected .yotpo-subscription-label-price",
      atcPriceContainer: ".sticky_atc_price",
      productInfoPrice: "span.price-item.price-item--regular",
      yotpoRadioLabel: ".yotpo-radio-label",
      yotpoSubscriptionLabel: ".yotpo-subscription-label-price",
    },
    event: {
      click: "click",
    },
  };

  const $yotpoSubs = document.querySelector(config.dom.yotpoSubs);

  if (typeof $yotpoSubs === "undefined" || $yotpoSubs === null) return;

  const $productInfoPrice = document.querySelector(config.dom.productInfoPrice);
  const $atcPriceContainer = document.querySelector(
    config.dom.atcPriceContainer
  );

  /**
   * Set Default Pricing
   */
  const setDefaultPricing = () => {
    const $yotpoSelectedPrice = document.querySelector(
      config.dom.yotpoSelectedPrice
    );

    $productInfoPrice.innerHTML = $yotpoSelectedPrice.textContent;
    $atcPriceContainer.innerHTML = "| " + $yotpoSelectedPrice.textContent;
  };

  /**
   * Handle Yotpo Radio Label Click
   * @param {Object} event Click Event
   */
  const handleYotpoRadioLabelClick = (event) => {
    const { parentElement: grandParentElement } = event.target.parentElement;
    const grandParentElementPrice = grandParentElement.querySelector(
      config.dom.yotpoSubscriptionLabel
    ).innerHTML;

    $productInfoPrice.innerHTML = grandParentElementPrice;
    $atcPriceContainer.innerHTML = grandParentElementPrice;
  };

  /**
   * Set Event Listeners
   */
  const setEventListeners = () => {
    const $yotpoRadioLabel = document.querySelectorAll(
      config.dom.yotpoRadioLabel
    );
    $yotpoRadioLabel.forEach((element) => {
      element.addEventListener(config.event.click, (event) => {
        handleYotpoRadioLabelClick(event);
      });
    });
  };

  /**
   * Init
   */
  const init = () => {
    setTimeout(() => {
      setDefaultPricing();
      setEventListeners();
    }, 500); // Required for onVariantChange / YOTPO subscription widget to fully load, then we can attach event listeners
  };

  init();
};

window.onload = () => productYotpoSubs();
